import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { DropdownTriggerButton } from 'module/ui/components/atoms/dropdown/trigger-button';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import {
  // faArrowTurnDownLeft,
  // faCopy,
  faEllipsis,
  faRefresh,
  // faThumbsDown,
  // faThumbsUp,
} from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import { Editor } from '@tiptap/core';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  askAiCommandDetailMap,
  askAiCommandsMenu,
} from '../../../../toolbar/ask-ai-commands';

const PrimaryActions = styled(CenterAlignedBox).attrs({ gap: 0 })`
  display: flex;
  align-items: center;
`;
const Actions = styled(CenterAlignedBox).attrs({ gap: 0 })`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface Props {
  editor: Editor;
  onAction: () => void;
}
export const OutputSectionFooter: FC<Props> = ({ editor, onAction }) => {
  return (
    <Actions>
      <PrimaryActions>
        <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faRefresh} size={12} />}
          onClick={onAction}
        >
          <FormattedMessage id="replace" />
        </Button>
        {/* <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faArrowTurnDownLeft} size={12} />}
          onClick={onAction}
        >
          <FormattedMessage id="insert_below" />
        </Button> */}
        <Dropdown
          menu={{
            onClick: ({ key }) => {
              return askAiCommandDetailMap[key].execute({
                editor,
              });
            },
            items: askAiCommandsMenu as ItemType[],
          }}
        >
          <DropdownTriggerButton
            icon={<FontAwesomeIcon icon={faEllipsis} size={12} />}
          />
        </Dropdown>
      </PrimaryActions>
      {/* <SecondaryActions>
        <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faCopy} size={12} />}
        />
        <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faThumbsUp} size={12} />}
        />
        <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faThumbsDown} size={12} />}
        />
        <Button
          size="small"
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={faEllipsis} size={12} />}
        />
      </SecondaryActions> */}
    </Actions>
  );
};
